import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../Client";
import imageUrlBuilder from "@sanity/image-url";
import BlockContent from "@sanity/block-content-to-react";
import { motion } from "framer-motion";
import { fadeInUp, slideOne, slideTwo } from "../Animation";


const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}

export default function OnePost() {
  const [postData, setPostData] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == $slug]{
          title,
          slug,
          mainImage{
            asset->{
              _id,
              url
             }
           },
         body,
        "name": author->name,
        "authorImage": author->image
       }`,
        { slug }
      )
      .then((data) => setPostData(data[0]))
      .catch(console.error);
  }, [slug]);

  if (!postData) return <div className="loading"></div>;

  return (
    <div className="bg-red-50 min-h-screen p-12 ">
      <div>
        <div>
          <motion.h2 className="text-base lg:text-6xl font-bold uppercase flex justify-center pb-8" variants={fadeInUp} initial="hidden" animate="show">{postData.title}</motion.h2>
        </div>
        <img className="w-full object-cover changeHeight"
          src={urlFor(postData.mainImage)}
          alt='main pic of the post'
        />
        <motion.div className="slide-1" variants={slideOne} initial="hidden" animate="show"></motion.div>
        <motion.div className="slide-2" variants={slideTwo} initial="hidden" animate="show"></motion.div>
        <div className="content my-12">
          <BlockContent
            blocks={postData.body}
            projectId={sanityClient.clientConfig.projectId}
            dataset={sanityClient.clientConfig.dataset}
          />
        </div>
        <div className="mt-10 md:mt-40 flex justify-center items-center roundContent">
            <img className="rounded-full contentImage"
              src={urlFor(postData.authorImage).width(130)}
              alt='author is Sarah'
            />
            <h4 className="flex items-center pl-2 md:text-2xl text-base"> <span className="text-gray-500 pr-2">Author:</span>{postData.name}</h4>
          </div>
      </div>
    </div>
  );
}
